module.exports = __webpack_public_path__ + "static/vslide_3@2x-6b14f342d5e2957a5e94f5b095333aca.png";